module.exports = "/_next/static/images/Criticalillustration-cf92f39ac764c8e26ecbcec07db3bc03.svg";